var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBluesMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Instrument-Trumpet-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Instrument Trumpet 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.71 8.78a1 1 0 0 0 0 -1.42L16.64 0.29a1 1 0 0 0 -1.42 0 1.53 1.53 0 0 0 -0.43 1.27 10.11 10.11 0 0 1 -1.23 6.24 0.25 0.25 0 0 0 0 0.25 0.23 0.23 0 0 0 0.22 0.12 6 6 0 0 1 3.94 1.43 0.24 0.24 0 0 0 0.24 0.05 10.23 10.23 0 0 1 4.48 -0.44 1.53 1.53 0 0 0 1.27 -0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.71 14.74 1.5 -1.5a1 1 0 0 0 -1.42 -1.42l-1.5 1.5a1 1 0 1 0 1.42 1.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.6a0.2 0.2 0 0 1 0 -0.25A4.5 4.5 0 0 0 10.65 11l-8.42 8.63a0.29 0.29 0 0 1 -0.18 0.07 0.24 0.24 0 0 1 -0.18 -0.07l-0.16 -0.17a1 1 0 0 0 -1.42 1.42l2.83 2.83a1 1 0 0 0 1.4 0 1 1 0 0 0 0 -1.41l-0.19 -0.19a0.24 0.24 0 0 1 0 -0.35l0.54 -0.56a0.26 0.26 0 0 1 0.21 -0.07 0.25 0.25 0 0 1 0.19 0.12 4.62 4.62 0 0 0 0.74 1 4.5 4.5 0 0 0 6.37 0 0.27 0.27 0 0 1 0.18 -0.08 0.25 0.25 0 0 1 0.18 0.08l0.52 0.52a1 1 0 0 0 1.42 -1.42l-0.57 -0.56a0.25 0.25 0 0 1 0 -0.35l1.2 -1.27a0.23 0.23 0 0 1 0.18 -0.07 0.22 0.22 0 0 1 0.18 0.07l0.59 0.6a1 1 0 0 0 1.42 -1.42Zm-8.9 0.29a0.25 0.25 0 0 1 0.18 -0.08 0.29 0.29 0 0 1 0.18 0.07l1.83 1.83a0.25 0.25 0 0 1 0 0.35 1.49 1.49 0 0 1 -2.12 0 1.56 1.56 0 0 1 -0.09 -2.15Zm6.77 -2.65a0.15 0.15 0 0 1 -0.22 0l-1.89 -1.89a0.16 0.16 0 0 1 0 -0.24 1.5 1.5 0 1 1 2.11 2.13Zm-1.66 1.39a0.25 0.25 0 0 1 0 0.35L12 18.25a0.22 0.22 0 0 1 -0.17 0.07 0.2 0.2 0 0 1 -0.18 -0.07l-1.81 -1.8a0.25 0.25 0 0 1 0 -0.36l1.22 -1.24a0.23 0.23 0 0 1 0.17 -0.08 0.29 0.29 0 0 1 0.18 0.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.21 11.24 1.5 -1.5a1 1 0 0 0 -1.42 -1.42l-1.5 1.5a1 1 0 1 0 1.42 1.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBluesMusic);
export default ForwardRef;